import React,{ useState, useRef, useEffect } from "react";

export const MultiSelect  = (
    {
        data,
        search =  true,
        setEdit,
        keyEdit,
        width,
        defaultValue,
        isBlocket = false,
    }) => 
{

    const claveData = Object.keys(data[0]||[]) // ClaveData son los nombres en cada objeto {'codigo':0,'nombre':'a'}
    const [ verDetalleSelect, setVerDetalleSelect ] = useState(false);
    const [ nombreSeleccionado, setNombreSeleccionado ] = useState([]);
    const [ valorSeleccionado, setValorSeleccionado ] = useState([]);
    const [ busqueda, setBusqueda ] = useState('');
    const [ nombreSelect, setNombreSelect ] = useState('--Seleccione--')
    const contenedorOpcionRef = useRef(null);
    const vistaSelectRef = useRef(null);

    useEffect(() => {
        if(defaultValue !== 0 && defaultValue !== ''){
            const usuarioRegistrados = defaultValue?.split(',').map(valor => (valor).toString());
            const nombre = []
            nombre.push(
                data
                .filter(d => usuarioRegistrados.includes(d[claveData[0]]))
                .map(item => item[claveData[0]])
            )
            setValorSeleccionado(...valorSeleccionado, usuarioRegistrados);
            setNombreSeleccionado(...nombreSeleccionado, nombre);
        }
    },[])

    useEffect(() => {
        if(valorSeleccionado.length > 0){
            console.log('',nombreSeleccionado?.join(', '))
            setNombreSelect(valorSeleccionado.length > 3 ? `${valorSeleccionado.length} items seleccionado` : nombreSeleccionado?.join(', '))
        }
        else{
            setNombreSelect('--Seleccione--')
        }
    },[valorSeleccionado])

    useEffect(() => {
        document.addEventListener('mousedown',(event) =>{
            if(
                verDetalleSelect && contenedorOpcionRef.current &&
                !contenedorOpcionRef.current.contains(event.target) && 
                !vistaSelectRef.current.contains(event.target)
            ){
                setVerDetalleSelect(false)
            }
        })
    },[verDetalleSelect])

    const cambioCheckSeleccionado = (event) => {
        const { value, checked, id } = event.target;
        let nuevoValor,nuevoNombre;
        if (checked) {
            nuevoValor = [...valorSeleccionado, value];
            nuevoNombre = [...nombreSeleccionado, id];
        }
        else {
            nuevoValor = valorSeleccionado.filter(item => item !== value);
            nuevoNombre = nombreSeleccionado.filter(item => item !== id);
        }
        setNombreSeleccionado(nuevoNombre)
        setValorSeleccionado(nuevoValor)
        setEdit(keyEdit, nuevoValor.join(','))
    }

    const mostrarOpciones = (event) => {
        if(data.length === 0 || isBlocket){
            event.preventDefault();
            return
        }
        setVerDetalleSelect(!verDetalleSelect)
    }

    const ocultarContenido = (event) =>{
        if (!contenedorOpcionRef?.current?.contains(event.relatedTarget)) {
            setVerDetalleSelect(false);
        }
    }
    
    const entradaBusqueda = (event) => {
        setBusqueda(event.target.value)
    }

    const dataFiltrada = data.filter(item => item[claveData[1]].toLowerCase().includes(busqueda.toLowerCase()))


    return(
        <>
            <section className={`${width ? width : ' w-[350px] '} `}>
                <section
                    ref={vistaSelectRef}
                    className={`bg-zinc-800  rounded-md w-full flex items-center
                        px-2 h-[30px] lg:h-[25px] lg:text-xs cursor-pointer`}
                    onClick={mostrarOpciones}
                    onBlur={ocultarContenido}
                >
                    <section className="w-[95%] flex justify-center items-center">
                        <span
                            className="w-max-[95%] whitespace-nowrap text-ellipsis overflow-hidden px-2 inline-block"
                        >
                            {nombreSelect}
                        </span>
                    </section>
                    <section className="w-[5%]">
                        <i className={`${!verDetalleSelect ? ' fa fa-angle-down ' : ' fa fa-angle-up '}`}></i>
                    </section>
                </section>
                {
                    verDetalleSelect && 
                    <section 
                        className={`${width ? width : ' w-[350px] '} absolute min-h-[50px] max-h-[350px] h-auto bg-zinc-600 rounded-md z-10`}
                        ref={contenedorOpcionRef}
                    >
                        {
                            search &&
                            <div className="h-[40px] bg-zinc-600 rounded-t-md flex items-center px-2 border-b border-zinc-900">
                                <input
                                    className="bg-zinc-800 rounded-md  w-[90%] px-2 caret-white focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    type="text"
                                    placeholder="Búsqueda"
                                    onChange={entradaBusqueda}
                                />
                                <i className="fa fa-search px-2 cursor-pointer"></i>
                            </div>
                        }
                        <div className={`containerScroll min-h-[20px] ${search ? ' max-h-[160px] ' : ' max-h-[200px] '} h-auto overflow-y-auto py-1`}>
                            {
                                dataFiltrada.length > 0 ?
                                    dataFiltrada.map((d,i) => {
                                        return(
                                            <div
                                                key={d[claveData[0]]}
                                                className={`flex gap-2 p-2 items-center 
                                                    ${valorSeleccionado?.includes((d[claveData[0]]).toString()) ? 'hover:bg-blue-700 bg-blue-400' : 'hover:bg-zinc-900'}`
                                                }
                                            >
                                                <input
                                                    type="checkbox"
                                                    value={d[claveData[0]]}
                                                    id={d[claveData[1]]}
                                                    className="w-5 h-5 rounded-md bg-zinc-700 hover:ring-blue-500"
                                                    onChange={cambioCheckSeleccionado}
                                                    checked={valorSeleccionado?.includes((d[claveData[0]]).toString())}
                                                />
                                                <label 
                                                    className="whitespace-nowrap text-ellipsis overflow-hidden"
                                                    htmlFor={d[claveData[1]]}
                                                    title={d[claveData[1]]}
                                                >
                                                {d[claveData[1]]}
                                                </label>
                                            </div>
                                        )
                                    })
                                : <p className="w-full px-2 text-center">No hay datos para mostrar</p>
                            }
                        </div>
                    </section>
                }

            </section>
        </>
    )
}